import {gql} from 'apollo-angular';
import {StatusFragment} from "./fragments/Status";

export const SET_TROPHY_COUNT = gql`
  query SetTrophyCount($clientId: String!, $classCode: String!, $itemId: String!, $itemType: TrophyItemType!) {
    trophyCount(clientId: $clientId, classCode: $classCode, itemId: $itemId, itemType: $itemType){
      ...statusFields
    }
  }
  ${StatusFragment}
`;
